import withResponsive from "../hoc/withResponsive";

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default withResponsive({
  name: "email-hide",

  events: [
    {
      on: "click",
      handle() {
        if (this.emailAddress) {
          this.el.setAttribute("href", `mailto:${this.emailAddress}`);
        }
      }
    }
  ],

  componentDidMount() {
    if (this.props.to && this.props.at) {
      this.emailAddress = `${this.props.to}@${this.props.at}`;
      this.el.innerText = this.emailAddress;
    }
  }
});
